import jwt_decode from "jwt-decode";
import { refreshAccessToken } from "./request";
import store from "@/store";
import { COOKIE_OPTIONS_SUFFIX, COOKIE_CLEAR_SUFFIX } from "@/utils/cookieConfig";
import { eventBus } from "@/utils/eventBus";

// Set Token
// export const setToken = (token) => {
//   const TokenKey = localStorage.setItem("vue_token", token);
//   return TokenKey;
// };

// Remove Token
export const removeToken = () => {
  return localStorage.removeItem("vue_token");
};

// export const getToken = () => {
//   return localStorage.getItem("vue_token");
// };

export const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getRefreshToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "refreshToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const setRefreshToken = (token) => {
  document.cookie = `refreshToken=${token}; ${COOKIE_OPTIONS_SUFFIX}`;
};

export const setToken = (token) => {
  document.cookie = `accessToken=${token}; ${COOKIE_OPTIONS_SUFFIX}`;
  localStorage.setItem("vue_token", token);
};

export const checkAccess = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
  if (cur[0].trim() === "candidate") {
        if (cur[1] === "no-access") {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
};


export const checkTokenExpiry = () => {
  // let cookieToken = localStorage.getItem("vue_token");
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let time = null;
  let currentTime = Math.floor(new Date().getTime());
  if (currentTime >= decoded.exp * 1000) {
    time = false;
  } else {
    time = true;
  }
  return time;
};

export const startTokenExpiryWatcher = () => {
  setInterval(async () => {
    if (checkBeforeTokenExpiry()) {
      // Token is expiring within the next 5 minutes
      // Refresh the token based on login type
      await refreshAccessToken();
    }
  }, 60000); // Check every 1 minute
};

export const checkBeforeTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let expirationTime = decoded.exp * 1000;
  let currentTime = Math.floor(new Date().getTime());
  let timeDifference = expirationTime - currentTime;
  console.log(timeDifference);
  //check if token expires within 5 minutes
  if (timeDifference <= 300000) {
    return true;
  } else {
    return false;
  }
};

export const getLoginType = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "loginData") {
        console.log(cur[0])
        return JSON.parse(cur[1]);
      }
    }
  }
  return null;
}

export const getMobileToken = () => {
	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		for (let i in data) {
			let cur = data[i].split("=");
			if (cur[0].trim() === "mobileToken") {
				return JSON.parse(cur[1]).token;
			}
		}
	}
	return null;
};

export const clearCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    if (name != "hire3x_heera_notifications") {
			document.cookie = `${name}=; ${COOKIE_CLEAR_SUFFIX}`;
		}
  }
  const adminState = localStorage.getItem("simpAdminState");
  localStorage.clear();
  if (adminState) {
    localStorage.setItem("simpAdminState", adminState);
  }
};

export const clearAllCookiesExceptGuest = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

    // Skip guest_uuid
    if (name === "guest_uuid"  || name === "hire3x_heera_notifications") continue;

    document.cookie = `${name}=; ${COOKIE_CLEAR_SUFFIX}`;
  }
};

// Guest UUID management for anonymous search history
export const getGuestUUID = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "guest_uuid") {
        return cur[1];
      }
    }
  }

  return null;
};

export const setGuestUUID = (uuid) => {
  document.cookie = `guest_uuid=${uuid}; ${COOKIE_OPTIONS_SUFFIX}`;
};

export const ensureGuestUUID = () => {
  let uuid = getGuestUUID();
  if (!uuid) {
    uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );
    setGuestUUID(uuid);
  }
  return uuid;
};

export const clearGuestUUID = () => {
  document.cookie = `guest_uuid=; ${COOKIE_CLEAR_SUFFIX}`;
};

export const getAccess = (value) => {
  let data = document.cookie.split(";");
  for (let i in data) {
    let cur = data[i].split("=");
    if (cur[0].trim() === value && cur[1] != 'no-access') {
      return cur[1];
    }
  }
  return null
  // return localStorage.getItem("vue_token");
}

export const hasAccess = () => {
  // if(getToken() && getAccess("candidate")) return true;
  // return false;
  return store.getters["userVUEX/getCandAccess"];
}

export const openLoginModal = ({ mode = "login", redirectUrl = null } = {}) => {
  eventBus.$emit("open-login-modal", { mode, redirectUrl });
};
